import { errorPlayerNotCreated, playOptions, } from './utils';
export const playerPlayVod = (player, parameters) => {
    if (!player) {
        throw errorPlayerNotCreated;
    }
    return player.playVod(parameters.termToken, parameters.teasableId, parameters.teasableType, playOptions(parameters.options));
};
